import type { CtcaeTerm, CtcaeVersion } from "./types";

const cache = new Map<CtcaeVersion, CtcaeTerm[]>();

export async function loadTerms(version: CtcaeVersion): Promise<CtcaeTerm[]> {
  const cached = cache.get(version);
  if (cached) return cached;
  const response = await fetch(`/data/ctcae-v${version[0]}.json`);
  if (!response.ok) throw new Error(`Unable to load CTCAE v${version}.`);
  const records = (await response.json()) as CtcaeTerm[];
  cache.set(version, records);
  return records;
}

export function getTerm(records: CtcaeTerm[], id: string) {
  return records.find((record) => record.id === id);
}

export function findEquivalentTerm(records: CtcaeTerm[], term: CtcaeTerm) {
  return records.find((record) => record.code === term.code);
}

export function findDeepLink(records: CtcaeTerm[], pathname = window.location.pathname) {
  const match = pathname.match(/^\/ctcae\/(5\.0|6\.0)\/([^/]+)\/([^/]+)\/?$/);
  if (!match) return undefined;
  return records.find((record) => record.version === match[1] && record.socSlug === match[2] && record.slug === match[3]);
}

export function termPath(record: CtcaeTerm) {
  return `/ctcae/${record.version}/${record.socSlug}/${record.slug}`;
}

export function getSocs(records: CtcaeTerm[]) {
  return [...new Set(records.map((record) => record.soc))].sort((a, b) => a.localeCompare(b));
}
